import { Navigate, Route, Routes } from 'react-router-dom';
import { PageTitle } from '../../../_start/layout/core';
import { ManageRedirectLinkPage } from './pages/ManageRedirectLinkPage';
import { RedirectLinkPage } from './pages/RedirectLinksPage';

export const RedirectLinkManagementPage = () => {
  return (
    <Routes>
      <Route
        path="links"
        element={
          <>
            <PageTitle>Redirect Link</PageTitle>
            <RedirectLinkPage />
          </>
        }
      />
      <Route
        path="links/manage-links"
        element={
          <>
            <PageTitle>Redirect Link</PageTitle>
            <ManageRedirectLinkPage />
          </>
        }
      />
      <Route
        path="links/:redirect_link_id/update"
        element={
          <>
            <PageTitle>Redirect Link</PageTitle>
            {/* <UpdateCustomerPage /> */}
          </>
        }
      />

      <Route
        index
        element={<Navigate to="/redirect-link-management/links" replace />}
      />
      <Route
        path="*"
        element={<Navigate to="/redirect-link-management/links" replace />}
      />
    </Routes>
  );
};
